export interface JobFolderType {
  id: string;
  folderName: string;
  createdAt: string;
  users: string[];
  folderKey: UploadKeys;
}

export interface FolderModal {
  handleClose: () => void;
  open: boolean;
  folderData: FolderData;
  isHistoryPage: boolean;
}

export interface FolderData {
  folderName: string;
  folderKey: UploadKeys;
  files: JobFile[];
}

export interface FolderFiles {
  path: string;
  jobId: number;
  fileName: string;
  fileSize: number;
  owner: Owner;
  createdAt: string;
}

export interface Owner {
  email: string;
  firstName: string;
  initial: string | null;
  lastName: string;
  _id: string;
}

export interface LoaderType {
  loading: boolean;
  error: string | null | any;
}
export interface JobFiles {
  folderKey: UploadKeys;
  files: JobFile[];
  isUploaderView?: boolean;
  setDownloadFile?: Function;
  selectAll?: string[];
  setLoader?: Function;
  /** Super Admin only - see JobFolderModal. Server enforces this independently. */
  canDeleteFiles?: boolean;
  /** Raises a single-file delete to the parent, which owns the confirmation dialog. */
  onRequestDelete?: (file: JobFile) => void;
}

export enum UploadKeys {
  orms = 'orms',
  deliverable = 'deliverable',
  shared = 'shared',
  externalConsultant = 'externalConsultant',
  internalConsultant = 'internalConsultant',
  contractor = 'contractor',
}

export interface JobFileUploderViewModal {
  folderKey: UploadKeys;
  backToFileUploderViews: (value: boolean) => void;
}

export interface JobFolderType {
  _id: UploadKeys;
  files: Array<JobFile>;
}

export interface JobFile {
  _id: string;
  fileName: string;
  owner: JobOwner;
  path: string;
  jobId: string;
  fileSize: number;
  createdAt: string;
  publicUrl?: string;
  expirePublicUrlAt?: Date;
  updatedAt: string;
}

export interface JobOwner {
  _id: string;
  firstName: string;
  lastName: string;
  initial: string | null;
  email: string;
}

/**
 * Message shown when a download fails and the server gave us no usable reason of its
 * own. Lives here (a leaf module) rather than in a component so both the file list and
 * the folder modal can share it without creating an import cycle.
 */
export const DOWNLOAD_FAILED_FALLBACK =
  'Could not download the file. Please try again.';
